var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.934 8.444h2.17V6.335c0-.931.024-2.366.7-3.255.712-.941 1.69-1.58 3.371-1.58 2.738 0 3.891.39 3.891.39l-.543 3.217s-.904-.263-1.748-.263c-.845 0-1.601.303-1.601 1.148v2.452h3.462l-.241 3.142h-3.22V22.5H9.104V11.586h-2.17V8.444",
    fill: "currentColor"
  })));
};
export default SvgFacebook;